import type {
  AppNotification,
  Message,
  MessageThread,
  OutboxEntry,
  Payment,
  ServiceOrder,
  Task,
} from '../types/platform';

export const messageThreads: MessageThread[] = [
  {
    id: 'thread-1',
    kind: 'candidate_recruiter',
    subject: 'Chief Operating Officer — VEN-2026-0114',
    candidateProfileId: 'cand-1',
    recruiterProfileId: 'rec-1',
    relatedOpportunityId: 'opp-1',
    relatedMandateId: 'mandate-1',
    lastMessageAt: '2026-08-31T16:42:00Z',
    createdAt: '2026-08-20T09:20:00Z',
  },
  {
    id: 'thread-2',
    kind: 'candidate_recruiter',
    subject: 'Executive résumé feedback',
    candidateProfileId: 'cand-2',
    recruiterProfileId: 'rec-1',
    relatedOpportunityId: 'opp-2',
    lastMessageAt: '2026-08-30T10:10:00Z',
    createdAt: '2026-08-27T13:20:00Z',
  },
  {
    id: 'thread-3',
    kind: 'employer_recruiter',
    subject: 'MND-2026-041 — shortlist and interview scheduling',
    employerProfileId: 'emp-1',
    recruiterProfileId: 'rec-1',
    relatedMandateId: 'mandate-1',
    lastMessageAt: '2026-08-31T14:25:00Z',
    createdAt: '2026-08-26T09:10:00Z',
  },
  {
    id: 'thread-4',
    kind: 'employer_recruiter',
    subject: 'MND-2026-038 — committee feedback',
    employerProfileId: 'emp-1',
    recruiterProfileId: 'rec-2',
    relatedMandateId: 'mandate-3',
    lastMessageAt: '2026-08-29T11:10:00Z',
    createdAt: '2026-08-21T10:00:00Z',
  },
];

export const messages: Message[] = [
  {
    id: 'msg-1',
    threadId: 'thread-1',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body:
      'Thank you for your application. I have opened preliminary review and would like to arrange a structured conversation this week. Before we speak, could you confirm whether the ambulatory expansion work you referenced was under your direct accountability or a peer’s?',
    sentAt: '2026-08-20T09:20:00Z',
    readByUserIds: ['user-cand-1', 'user-rec-1'],
  },
  {
    id: 'msg-2',
    threadId: 'thread-1',
    authorUserId: 'user-cand-1',
    authorName: 'Marion T. Whitfield',
    authorRoleLabel: 'Candidate',
    body:
      'It was a peer’s accountability, though I chaired the operating committee that approved the site selection and the capital case. I would rather that were clear to the client from the outset than discovered later.',
    sentAt: '2026-08-20T18:05:00Z',
    readByUserIds: ['user-cand-1', 'user-rec-1'],
  },
  {
    id: 'msg-3',
    threadId: 'thread-1',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body:
      'Noted, and I have reflected that distinction in the written assessment rather than smoothing it over. The client has asked to meet you. Availability options are in your portal under Interviews, and a briefing note is in your document centre.',
    sentAt: '2026-08-28T10:20:00Z',
    readByUserIds: ['user-cand-1', 'user-rec-1'],
  },
  {
    id: 'msg-4',
    threadId: 'thread-1',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body:
      'The 9 September slot is confirmed. The panel is the Chief Executive Officer and the Chief Human Resources Officer. Ninety minutes, in person.',
    sentAt: '2026-08-31T16:42:00Z',
    readByUserIds: ['user-rec-1'],
  },
  {
    id: 'msg-5',
    threadId: 'thread-2',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body:
      'I have completed the review of your résumé and left three specific items in your document centre. To be clear about what this is: the underlying experience is genuinely relevant to this mandate. The document is currently understating it. This is not a suggestion that you need to purchase anything — the changes are straightforward and you should make them yourself.',
    sentAt: '2026-08-27T13:20:00Z',
    readByUserIds: ['user-cand-2', 'user-rec-1'],
  },
  {
    id: 'msg-6',
    threadId: 'thread-2',
    authorUserId: 'user-cand-2',
    authorName: 'Devon R. Achebe',
    authorRoleLabel: 'Candidate',
    body: 'Understood and appreciated. Updated version uploaded.',
    sentAt: '2026-08-29T21:12:00Z',
    readByUserIds: ['user-cand-2', 'user-rec-1'],
  },
  {
    id: 'msg-7',
    threadId: 'thread-2',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body:
      'Accepted. All three points addressed. I am advancing you to search-team review and will come back about presentation authorization.',
    sentAt: '2026-08-30T10:10:00Z',
    readByUserIds: ['user-cand-2', 'user-rec-1'],
  },
  {
    id: 'msg-8',
    threadId: 'thread-3',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body:
      'One authorized candidate is now available in your portal with the written assessment. Two further candidates are in the process; they will appear only once each has authorized presentation to you.',
    sentAt: '2026-08-26T09:10:00Z',
    readByUserIds: ['user-emp-1', 'user-rec-1'],
  },
  {
    id: 'msg-9',
    threadId: 'thread-3',
    authorUserId: 'user-emp-1',
    authorName: 'Helena M. Osei',
    authorRoleLabel: 'Employer',
    body:
      'Feedback submitted. The Chief Executive Officer would like to meet. Can we offer three slots in the week of 8 September?',
    sentAt: '2026-08-28T16:25:00Z',
    readByUserIds: ['user-emp-1', 'user-rec-1'],
  },
  {
    id: 'msg-10',
    threadId: 'thread-3',
    authorUserId: 'user-rec-1',
    authorName: 'Claudia B. Nwosu',
    authorRoleLabel: 'Recruiter',
    body: 'Confirmed for 9 September at 15:00. I have briefed the candidate on the panel and format.',
    sentAt: '2026-08-31T14:25:00Z',
    readByUserIds: ['user-rec-1'],
  },
  {
    id: 'msg-11',
    threadId: 'thread-4',
    authorUserId: 'user-emp-1',
    authorName: 'Helena M. Osei',
    authorRoleLabel: 'Employer',
    body:
      'The committee is positive on the regulatory record but wants to understand what support structure would be needed in year one given this would be a first top-seat appointment.',
    sentAt: '2026-08-29T11:10:00Z',
    readByUserIds: ['user-emp-1', 'user-rec-2'],
  },
];

export const notifications: AppNotification[] = [
  {
    id: 'note-1',
    userId: 'user-cand-1',
    type: 'interview_request',
    title: 'Interview requested — VEN-2026-0114',
    body: 'The client has requested a first interview. Confirm your availability in your portal.',
    linkTo: '/portal/candidate/interviews',
    createdAt: '2026-08-28T10:16:00Z',
  },
  {
    id: 'note-2',
    userId: 'user-cand-1',
    type: 'new_message',
    title: 'New message from Claudia B. Nwosu',
    body: 'Your 9 September interview slot has been confirmed.',
    linkTo: '/portal/candidate/messages',
    createdAt: '2026-08-31T16:42:00Z',
  },
  {
    id: 'note-3',
    userId: 'user-cand-1',
    type: 'document_received',
    title: 'Professional references received',
    body: 'Your professional references document has been received and is awaiting review.',
    linkTo: '/portal/candidate/documents',
    createdAt: '2026-08-29T19:21:00Z',
    readAt: '2026-08-30T07:00:00Z',
  },
  {
    id: 'note-4',
    userId: 'user-cand-2',
    type: 'consent_request',
    title: 'Presentation authorization required',
    body:
      'Your authorization is required before your profile can be presented for VEN-2026-0118. The client’s identity is temporarily restricted and the reason is stated in the request.',
    linkTo: '/portal/candidate/consent',
    createdAt: '2026-08-31T11:01:00Z',
  },
  {
    id: 'note-5',
    userId: 'user-cand-2',
    type: 'document_review_completed',
    title: 'Document review completed',
    body: 'Your updated executive résumé has been accepted for the current stage.',
    linkTo: '/portal/candidate/documents',
    createdAt: '2026-08-30T10:01:00Z',
    readAt: '2026-08-30T12:00:00Z',
  },
  {
    id: 'note-6',
    userId: 'user-cand-4',
    type: 'application_received',
    title: 'Application received — APP-2026-1888',
    body: 'We have received your application for Chief Technology Officer. Your reference number is APP-2026-1888.',
    linkTo: '/portal/candidate/applications',
    createdAt: '2026-08-31T20:11:00Z',
  },
  {
    id: 'note-7',
    userId: 'user-emp-1',
    type: 'status_update',
    title: 'Interview confirmed — MND-2026-041',
    body: 'The candidate has confirmed availability for 9 September at 15:00.',
    linkTo: '/portal/employer/interviews',
    createdAt: '2026-08-31T14:26:00Z',
  },
  {
    id: 'note-8',
    userId: 'user-emp-2',
    type: 'registration_confirmation',
    title: 'Account created — verification pending',
    body:
      'Your employer account has been created and is pending administrator verification. You cannot submit a mandate or view candidate information until verification is complete.',
    linkTo: '/portal/employer/verification',
    createdAt: '2026-08-30T14:53:00Z',
  },
  {
    id: 'note-9',
    userId: 'user-rec-1',
    type: 'status_update',
    title: 'Authorization outstanding — pres-3',
    body: 'Devon R. Achebe has not yet responded to the presentation authorization request for MND-2026-044.',
    linkTo: '/portal/recruiter/consent',
    createdAt: '2026-09-01T07:00:00Z',
  },
  {
    id: 'note-10',
    userId: 'user-cand-3',
    type: 'privacy_request_confirmation',
    title: 'Privacy request received — PRQ-2026-0087',
    body: 'Your data download request has been received. We will confirm the outcome in writing.',
    linkTo: '/portal/candidate/privacy',
    createdAt: '2026-08-26T09:31:00Z',
    readAt: '2026-08-26T10:00:00Z',
  },
];

export const outbox: OutboxEntry[] = [
  {
    id: 'out-1',
    templateId: 'tpl-application-received',
    type: 'application_received',
    toEmail: 'candidate.tech@velnoris.demo',
    toName: 'Anders J. Lindqvist',
    subject: 'We have received your application — APP-2026-1888',
    renderedBody:
      'Dear Anders,\n\nWe have received your application for Chief Technology Officer (reference VEN-2026-0129). Your application reference is APP-2026-1888.\n\nA consultant will review your application. You can track its status at any time by signing in to your portal.\n\nWe do not attach documents to email. All materials are available through your portal.\n\nVelnoris Executive Network',
    sentAt: '2026-08-31T20:11:00Z',
    deliveryState: 'delivered',
    containsAttachment: false,
  },
  {
    id: 'out-2',
    templateId: 'tpl-interview-request',
    type: 'interview_request',
    toEmail: 'candidate@velnoris.demo',
    toName: 'Marion T. Whitfield',
    subject: 'Interview requested — VEN-2026-0114',
    renderedBody:
      'Dear Marion,\n\nThe client for reference VEN-2026-0114 has requested a first interview. Proposed times and a briefing note are available in your portal.\n\nSign in to confirm your availability.\n\nVelnoris Executive Network',
    sentAt: '2026-08-28T10:16:00Z',
    deliveryState: 'delivered',
    containsAttachment: false,
  },
  {
    id: 'out-3',
    templateId: 'tpl-revision-requested',
    type: 'revision_requested',
    toEmail: 'candidate.new@velnoris.demo',
    toName: 'Devon R. Achebe',
    subject: 'Document review completed — revision requested',
    renderedBody:
      'Dear Devon,\n\nA consultant has reviewed your executive résumé and requested a revision. Three specific items, each with a suggested action, are available in your document centre.\n\nThis review is part of our normal process. No paid service is required to act on it.\n\nSign in to your portal to read the feedback.\n\nVelnoris Executive Network',
    sentAt: '2026-08-27T13:16:00Z',
    deliveryState: 'delivered',
    containsAttachment: false,
  },
  {
    id: 'out-4',
    templateId: 'tpl-consent-request',
    type: 'consent_request',
    toEmail: 'candidate.new@velnoris.demo',
    toName: 'Devon R. Achebe',
    subject: 'Your authorization is required before we present your profile',
    renderedBody:
      'Dear Devon,\n\nBefore your profile can be presented for reference VEN-2026-0118, we need your specific authorization for this mandate.\n\nThe client has instructed that its identity be withheld until the shortlist stage because the incumbent remains in seat and has not been notified. Its identity will be disclosed to you before your profile is presented.\n\nYou may decline. Declining will not affect your candidacy or your access to any other opportunity.\n\nSign in to your portal to respond.\n\nVelnoris Executive Network',
    sentAt: '2026-08-31T11:01:00Z',
    deliveryState: 'delivered',
    containsAttachment: false,
  },
  {
    id: 'out-5',
    templateId: 'tpl-opportunity-match',
    type: 'opportunity_match',
    toEmail: 'candidate.energy@velnoris.demo',
    toName: 'Thomas O. Baptiste',
    subject: 'A potential match in your area of expertise',
    renderedBody:
      'Dear Tom,\n\nA mandate in our energy and infrastructure practice may be a potential match for your profile. This is not a determination that you are qualified, and consideration is not guaranteed.\n\nSign in to review it.\n\nYou can change what we notify you about at any time in your notification preferences.\n\nVelnoris Executive Network',
    sentAt: '2026-08-24T09:00:00Z',
    deliveryState: 'delivered',
    containsAttachment: false,
  },
  {
    id: 'out-6',
    templateId: 'tpl-privacy-confirmation',
    type: 'privacy_request_confirmation',
    toEmail: 'candidate.board@velnoris.demo',
    toName: 'Priya N. Raghunathan',
    subject: 'Privacy request received — PRQ-2026-0087',
    renderedBody:
      'Dear Priya,\n\nWe have received your data download request. Your reference is PRQ-2026-0087.\n\nWe will confirm the outcome in writing. If we need to verify your identity first, we will tell you what is required and why.\n\nVelnoris Executive Network',
    sentAt: '2026-08-26T09:31:00Z',
    deliveryState: 'delivered',
    containsAttachment: false,
  },
  {
    id: 'out-7',
    templateId: 'tpl-opportunity-match',
    type: 'opportunity_match',
    toEmail: 'candidate@velnoris.demo',
    toName: 'Marion T. Whitfield',
    subject: 'A potential match in your area of expertise',
    renderedBody: 'Suppressed. Recipient has withdrawn consent for marketing communications.',
    sentAt: '2026-08-24T09:00:00Z',
    deliveryState: 'suppressed_unsubscribed',
    containsAttachment: false,
  },
];

export const tasks: Task[] = [
  {
    id: 'task-1',
    assignedToUserId: 'user-rec-1',
    title: 'Chase presentation authorization — Devon R. Achebe',
    detail: 'Authorization requested 31 August for MND-2026-044. No response yet. Do not present without it.',
    dueAt: '2026-09-02T09:00:00Z',
    relatedMandateId: 'mandate-2',
    relatedCandidateProfileId: 'cand-2',
    relatedApplicationId: 'app-2',
    priority: 'high',
    createdAt: '2026-08-31T11:05:00Z',
  },
  {
    id: 'task-2',
    assignedToUserId: 'user-rec-1',
    title: 'Redirect Thomas O. Baptiste to MND-2026-042',
    detail: 'Not credible for the defense capture requirement. Genuine fit on the renewables development mandate.',
    dueAt: '2026-09-02T17:00:00Z',
    relatedMandateId: 'mandate-8',
    relatedCandidateProfileId: 'cand-6',
    priority: 'normal',
    createdAt: '2026-08-24T10:30:00Z',
  },
  {
    id: 'task-3',
    assignedToUserId: 'user-rec-1',
    title: 'Brief candidate for 9 September client interview',
    detail: 'Panel is CEO and CHRO. Confirm the briefing note has been read.',
    dueAt: '2026-09-05T12:00:00Z',
    relatedMandateId: 'mandate-1',
    relatedCandidateProfileId: 'cand-1',
    priority: 'high',
    createdAt: '2026-08-31T16:45:00Z',
  },
  {
    id: 'task-4',
    assignedToUserId: 'user-rec-1',
    title: 'Review professional references — Marion T. Whitfield',
    dueAt: '2026-09-03T09:00:00Z',
    relatedCandidateProfileId: 'cand-1',
    priority: 'normal',
    createdAt: '2026-08-29T19:25:00Z',
  },
  {
    id: 'task-5',
    assignedToUserId: 'user-rec-1',
    title: 'Complete market map — MND-2026-044 longlist',
    dueAt: '2026-09-08T17:00:00Z',
    relatedMandateId: 'mandate-2',
    priority: 'normal',
    createdAt: '2026-08-26T09:00:00Z',
  },
  {
    id: 'task-6',
    assignedToUserId: 'user-rec-1',
    title: 'Submit progress report to client — MND-2026-036',
    dueAt: '2026-08-30T17:00:00Z',
    relatedMandateId: 'mandate-7',
    priority: 'high',
    completedAt: '2026-08-29T15:10:00Z',
    createdAt: '2026-08-22T09:00:00Z',
  },
];

export const serviceOrders: ServiceOrder[] = [
  {
    id: 'so-1',
    reference: 'ECS-2026-0311',
    candidateProfileId: 'cand-3',
    serviceSlug: 'board-value-proposition',
    serviceName: 'Board Value Proposition',
    status: 'completed',
    revisionsIncluded: 1,
    revisionsUsed: 1,
    consultationRequestedAt: '2026-05-20T10:00:00Z',
    deliveredAt: '2026-06-04T14:00:00Z',
    notes:
      'Delivered and one revision used. Recorded against the candidate’s career-services history only. No bearing on any application.',
  },
  {
    id: 'so-2',
    reference: 'ECS-2026-0348',
    candidateProfileId: 'cand-3',
    serviceSlug: 'interview-preparation',
    serviceName: 'Interview Preparation',
    status: 'consultation_requested',
    revisionsIncluded: 0,
    revisionsUsed: 0,
    consultationRequestedAt: '2026-08-30T18:20:00Z',
    notes: 'Consultation requested. No charge has been raised and no scope agreed.',
  },
];

export const payments: Payment[] = [
  {
    id: 'pay-1',
    serviceOrderId: 'so-1',
    amountUsd: 0,
    state: 'not_collected',
    recordedAt: '2026-06-04T14:00:00Z',
    note:
      'Payment processing is not enabled in this build. In production this record is created by the payment provider webhook, not by the client.',
  },
];
